import { gql } from '@apollo/client';

export const PUBLISH_TWITTER_IMAGE = gql`
    mutation PublishTwitterImage($input: PublishTwitterImageInput!) {
        publishTwitterImage(input: $input) {
            ... on PublishResultPayload {
                workflow {
                    id
                    executionId
                    startDate
                    status {
                        state
                        message
                    }
                }
            }
            ... on PublishError {
                code
                message
            }
        }
    }
`;
